import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { EMPLOYER_URL } from "../resources/resource";
import { toast } from "sonner";

const EmployeeTaxHistory = () => {
  const { employees, status } = useSelector((state) => state.employerEmployee || {});
  const [employerData, setEmployerData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Get unique employer IDs
  const employerIds = [...new Set(employees.map((employee) => employee.employer))];

  // Fetch employer data
  useEffect(() => {
  const fetchEmployers = async () => {
  if (employerIds.length === 0) return;

  setIsLoading(true);
  try {
    const employers = {};
    const promises = employerIds.map((id) =>
      axios.get(`${EMPLOYER_URL}/getEmployer/${id}`)
    );
    const responses = await Promise.all(promises);
    responses.forEach((response, index) => {
      employers[employerIds[index]] = response.data.companyName || "Unknown Employer";
    });
    setEmployerData(employers);
  } catch (err) {
    setError(err.message || "Failed to fetch employer data");
    toast.error("Error fetching employer data");
  } finally {
    setIsLoading(false);
  }
};
  })

  // Calculate tax history for all employees
  const taxHistory = employees.flatMap((employee) =>
    (employee?.salary?.history || []).map((hist) => ({
      employeeName: `${employee.firstName} ${employee.lastName}`,
      employer: employerData[employee.employer.companyName] || "Loading Employer...",
      period: `${hist.month} ${hist.year}`,
      tax: hist.deductions?.tax || 0,
    }))
  );

  console.log(employees, "your taxHistory");

  // Calculate total tax across all employees
  const totalTax = taxHistory.reduce((sum, entry) => sum + entry.tax, 0);

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <h2 className="text-3xl font-bold text-gray-800 mb-6">Tax History for All Employees</h2>
      {status === "loading" || isLoading ? (
        <p className="text-gray-500">Loading tax history...</p>
      ) : error ? (
        <p className="text-red-500">Error: {error}</p>
      ) : employees.length > 0 ? (
        <div className="bg-white p-6 rounded-lg shadow-lg">
          <h3 className="text-xl font-semibold mb-4">Tax Payments</h3>
          {taxHistory.length > 0 ? (
            <>
              <table className="w-full text-sm md:text-base">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="py-2 px-4 text-left">Employee</th>
                    <th className="py-2 px-4 text-left">Employer</th>
                    <th className="py-2 px-4 text-left">Period</th>
                    <th className="py-2 px-4 text-left">Tax Paid (₦)</th>
                  </tr>
                </thead>
                <tbody>
                  {taxHistory.map((entry, index) => (
                    <tr key={index} className="border-t">
                      <td className="py-2 px-4">{entry.employeeName}</td>
                      <td className="py-2 px-4">{entry.employer}</td>
                      <td className="py-2 px-4">{entry.period}</td>
                      <td className="py-2 px-4">{entry.tax.toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="mt-4 text-lg font-semibold">
                Total Tax Paid (All Employees): ₦{totalTax.toLocaleString()}
              </div>
            </>
          ) : (
            <p className="text-gray-500">No tax history available for any employees.</p>
          )}
        </div>
      ) : (
        <p className="text-gray-500">No employees available.</p>
      )}
    </div>
  );
};

export default EmployeeTaxHistory;